import React, { useEffect } from 'react';
import { Header } from './Header';
import { ShoppingCartButton } from './ShoppingCartButton';
import { PricingCard } from './PricingCard';
import { ProductCardList } from './ProductCardList';
import { ProductReturnSummary } from './ProductReturnSummary';
import { Testimonials } from './Testimonials';
import { BackgroundLoading } from './Backgorundloading';

import { PersonalInfo } from './PersonalInfo';
import { BillingDetails } from './BillingDetails';
import { FormSubmit } from './FormSubmit';
import { Footer } from './Footer';
import './style.scss';
import { UpsellCard } from './UpsellCard';

function App(props) {
	const {
		loading,
		billingInfo,
		setBillingInfo,
		billingInfoErrors,
		setBillingInfoErrors,
		hidePaymentOptions,

		requiredAddress,
		setRequiredAddress,

		loadingCountries,
		countryOptions,
		setCountryOptions,
		selectedCountry,
		setSelectedCountry,
		loadingStates,
		getStates,
		stateOptions,
		setStateOptions,
		selectedState,
		setSelectedState,
		setDisabledState,
		disabledState,

		profile,
		profileLoading,
		cartData,
		recaptureTrack,
		checkValidation,
		getFieldRules,

		// rightside
		removeFromCart,
		handleSubmit,
		total,
		processingCheckout,
		addToCart,
		renewalDiscount,
		cartLoading,
		coupon,
		showCoupon,
		setShowCoupon,
		couponProcessing,
		applyCoupon,
		couponCode,
		setCouponCode,
		couponError,
		setCouponError,
		handleShowCouponClick,
		couponRef,
		addToCartUpsell,
		showUpsell,
		licenseRenewing,
		disablePaymentBtn,
	} = props;

	const isLoading = loading || couponProcessing || cartLoading;

	useEffect(() => {}, [cartLoading]);

	return (
		<>
			<section className="wp-checkout-section wpdev-checkout-new-cart">
				<div className="wp-checkout-container-fluid">
					<Header />
					<div className="wp-checkout-row">
						<div className="wp-checkout-col-6">
							<div className="wp-checkout-left-content">
								<div className="wp-checkout-content-wrapper">
									<ShoppingCartButton />

									{isLoading && <BackgroundLoading />}
									{!isLoading && (
										<>
											{/* <PricingCard cartData={cartData} /> */}
											<ProductCardList
												cartData={cartData}
												addToCart={addToCart}
												cartLoading={cartLoading}
												removeFromCart={removeFromCart}
												setCouponCode={setCouponCode}
												couponCode={couponCode}
												coupon={coupon}
												addToCartUpsell={
													addToCartUpsell
												}
												processingCheckout={
													processingCheckout
												}
												renewalDiscount={
													renewalDiscount
												}
											/>

											{/* <UpsellCard
												cartData={cartData}
												coupon={coupon}
												addToCartUpsell={addToCartUpsell}
												// licenseKey={licenseKey}
												// setLicenseKey={setLicenseKey}
												cartLoading={cartLoading}
											/> */}

											<ProductReturnSummary
												cartData={cartData}
												applyCoupon={applyCoupon}
												setCouponCode={setCouponCode}
												couponCode={couponCode}
												coupon={coupon}
												couponError={couponError}
												couponProcessing={
													couponProcessing
												}
											/>
										</>
									)}

									<Testimonials />
								</div>
							</div>
						</div>
						<div className="wp-checkout-col-6">
							<div className="wp-checkout-right-content">
								<div className="wp-checkout-content-wrapper">
									<form>
										<PersonalInfo
											profile={profile}
											profileLoading={profileLoading}
											billingInfo={billingInfo}
											setBillingInfo={setBillingInfo}
											billingInfoErrors={
												billingInfoErrors
											}
											setBillingInfoErrors={
												setBillingInfoErrors
											}
											cartData={cartData}
											recaptureTrack={recaptureTrack}
											checkValidation={checkValidation}
											getFieldRules={getFieldRules}
											isLoading={loading}
										/>
										<BillingDetails
											loading={loading}
											profileLoading={profileLoading}
											checkValidation={checkValidation}
											hidePaymentOptions={
												hidePaymentOptions
											}
											billingInfoErrors={
												billingInfoErrors
											}
											billingInfo={billingInfo}
											setBillingInfo={setBillingInfo}
											requiredAddress={requiredAddress}
											setRequiredAddress={
												setRequiredAddress
											}
											loadingCountries={loadingCountries}
											countryOptions={countryOptions}
											setCountryOptions={
												setCountryOptions
											}
											selectedCountry={selectedCountry}
											setSelectedCountry={
												setSelectedCountry
											}
											loadingStates={loadingStates}
											getStates={getStates}
											stateOptions={stateOptions}
											setStateOptions={setStateOptions}
											selectedState={selectedState}
											setSelectedState={setSelectedState}
											setDisabledState={setDisabledState}
											disabledState={disabledState}
										/>
										<FormSubmit
											isLoading={isLoading}
											cartData={cartData}
											handleSubmit={handleSubmit}
											total={total}
											processingCheckout={
												processingCheckout
											}
											disablePaymentBtn={
												disablePaymentBtn
											}
										/>
									</form>
									<div className="wp-checkout-footer">
										<Footer />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default App;
